import React, { useMemo } from 'react'
import { Avatar, Badge, Popover } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { UserProfileMenu } from './user-profile-menu'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { useDemoPrivacy } from '../../contexts/demo-privacy-context'

const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)

const UserProfileWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 40px;
  height: 40px;

  li {
    padding: 0;
  }
`

const StyledAvatar = styled(Avatar)`
  background-color: #52c41a;
  font-size: 12px !important;
`

export const UserProfile = () => {
  const { sessionData } = useSelector(createSession)
  const { hidePhones } = useDemoPrivacy()
  const isAdmin = Boolean(sessionData?.roles?.includes(1))

  const initials = useMemo(() => {
    const name = sessionData?.user?.name || sessionData?.user?.login
    if (!name) return 'U'
    const [firstName, lastName] = name.split(' ')
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase()
  }, [sessionData])

  if (!sessionData?.user) {
    return null
  }

  return (
    <UserProfileWrapper>
      <Popover placement="bottomRight" content={<UserProfileMenu />} trigger="click">
        <Badge dot={isAdmin && hidePhones} color="#fa8c16" offset={[-4, 4]}>
          <StyledAvatar size={40} icon={!initials ? <UserOutlined /> : undefined}>
            {initials}
          </StyledAvatar>
        </Badge>
      </Popover>
    </UserProfileWrapper>
  )
}
